// Lightweight fetch wrapper with JWT + automatic refresh.
// Falls back gracefully if VITE_API_URL is not set (returns null → caller uses mocks).

const API_URL = import.meta.env.VITE_API_URL || '';
const USE_API = !!API_URL;

const TOKEN_KEY = 'lupa_access_token';
const REFRESH_KEY = 'lupa_refresh_token';
const USER_KEY = 'lupa_user';

export const tokens = {
  get access() { return localStorage.getItem(TOKEN_KEY); },
  get refresh() { return localStorage.getItem(REFRESH_KEY); },
  set(access, refresh) {
    if (access) localStorage.setItem(TOKEN_KEY, access);
    if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const userCache = {
  get() {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || 'null'); } catch { return null; }
  },
  set(u) {
    if (u) localStorage.setItem(USER_KEY, JSON.stringify(u));
    else localStorage.removeItem(USER_KEY);
  },
};

export const apiEnabled = USE_API;

let refreshing = null;

async function doRefresh() {
  const rt = tokens.refresh;
  if (!rt) throw new Error('no_refresh_token');
  const res = await fetch(`${API_URL}/api/auth/refresh`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ refreshToken: rt }),
  });
  if (!res.ok) throw new Error('refresh_failed');
  const data = await res.json();
  tokens.set(data.accessToken, data.refreshToken);
  if (data.user) userCache.set(data.user);
  return data.accessToken;
}

export async function api(path, options = {}) {
  if (!USE_API) return null;

  const url = `${API_URL}${path}`;
  const headers = { 'content-type': 'application/json', ...(options.headers || {}) };
  if (tokens.access && !options.skipAuth) {
    headers.authorization = `Bearer ${tokens.access}`;
  }

  let res = await fetch(url, { ...options, headers });

  // Auto-refresh on 401 (single-flight)
  if (res.status === 401 && tokens.refresh && !options.skipAuth && !options._retried) {
    try {
      refreshing = refreshing || doRefresh().finally(() => { refreshing = null; });
      const newAccess = await refreshing;
      headers.authorization = `Bearer ${newAccess}`;
      res = await fetch(url, { ...options, headers, _retried: true });
    } catch {
      tokens.clear();
      window.dispatchEvent(new CustomEvent('lupa:auth-expired'));
      throw new Error('session_expired');
    }
  }

  if (!res.ok) {
    let body = {};
    try { body = await res.json(); } catch {}
    const err = new Error(body.error || `http_${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }

  if (res.status === 204) return null;
  return res.json();
}
